
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalWhyUseOC',

    components: {
        ModalEducateUsers,
    },

    data() {
        return {
            steps: [],
        }
    },

    computed: {
        ...mapGetters('global', ['globalFreeShippingAmount']),

        getGlobalFreeShippingAmount() {
            return this.globalFreeShippingAmount
        },
    },

    created() {
        this.steps = [
            {
                title: `${this.$t('labels.order-online-title')}`,
                description: this.$t('labels.order-online-description'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~/assets/images/how-oc-works/why-use-oc-image-01.svg'),
            },
            {
                title: this.$t('labels.oc-is-free-title'),
                description: this.getGlobalFreeShippingAmount
                    ? this.$t('labels.oc-is-free-description', [
                          this.$n(
                              this.getGlobalFreeShippingAmount,
                              'currency-no-decimal'
                          ),
                      ])
                    : this.$t('labels.oc-is-free-description-no-freeshiping'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~/assets/images/how-oc-works/why-use-oc-image-02.svg'),
            },
            {
                title: this.$t('labels.build-relationships-title'),
                description: this.$t('labels.build-relationships-description'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~/assets/images/how-oc-works/why-use-oc-image-03.svg'),
            },
        ]
    },
}
